import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper.mjs';
import { Navigation, Pagination } from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/index.mjs';

/**
 * slider-products.js
 * Load in Liquid as:
 * <script type="module" src="{{ 'slider-products.js' | asset_url }}"></script>
 */

function initSliderProducts(host) {
  const swiperEl     = host.querySelector('[data-ref="slider"]');
  const prevEl       = host.querySelector('[data-ref="prev"]');
  const nextEl       = host.querySelector('[data-ref="next"]');
  const paginationEl = host.querySelector('[data-ref="pagination"]');

  if (!swiperEl) return null;

  const config = {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    slidesPerGroup: 2,
    // spaceBetween: 16,
    // breakpoints: {
    //   768:  { slidesPerGroup: 2, spaceBetween: 20 },
    //   1024: { slidesPerGroup: 3, spaceBetween: 24 },
    // },
  };

  if (prevEl && nextEl) {
    config.navigation = { prevEl, nextEl };
  }

  if (paginationEl) {
    config.pagination = { el: paginationEl, clickable: true };
  }

  return new Swiper(swiperEl, config);
}

function registerSliderProducts() {
  document.querySelectorAll('enno-component[name="SliderProducts"]').forEach(function(host) {
    if (host.getAttribute('load:on') === 'visible') {
      const observer = new IntersectionObserver(function(entries, obs) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            obs.unobserve(host);
            initSliderProducts(host);
          }
        });
      }, { rootMargin: '200px' });
      observer.observe(host);
    } else {
      initSliderProducts(host);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerSliderProducts);
} else {
  registerSliderProducts();
}
